export default __webpack_public_path__ + "static/media/nr.eb3ff14b.jpeg";